"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Popover_1 = __importDefault(require("@mui/material/Popover"));
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var WebLinkPopover = (0, styles_1.styled)(Popover_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiPaper-root': {
            marginTop: theme.spacing(2),
            width: '100%',
            maxWidth: 500,
            padding: theme.spacing(5, 4, 3, 4),
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.02), 0px 4px 6px rgba(0, 0, 0, 0.06), 0px 7px 16px rgba(15, 15, 15, 0.08)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(WebLinkPopover, {
    autoFocus: false,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'right',
    },
});
